import React, { Component } from 'react';
import { Modal, Form, Button } from 'react-bulma-components';
import AccountsStore from 'stores/AccountsOverview/AccountsStore';
import AccountEditor from './AccountEditor';

class AccountCreate extends Component {
  state = {
    number: '',
    error: '',
    showCreateConfirmation: false,
    showOpenConfirmation: false,
    showRevokeConfirmation: false,
    fetchedAccount: null,
  };

  handleChange = (e) => {
    this.setState({ number: e.target.value });
  };

  searchAccount = async () => {
    const { number } = this.state;
    const existingAccount = AccountsStore.list.accounts.find(account => account.number === number);

    if (existingAccount) {
      if (existingAccount.soft_deleted) {
        this.setState({ showRevokeConfirmation: true, fetchedAccount: existingAccount });
      } else {
        this.setState({ showOpenConfirmation: true, fetchedAccount: existingAccount });
      }
    } else {
      try {
        const account = await AccountsStore.fetchAccountByNumber(number);
        if (account.bc_bill_name) {
          this.setState({ fetchedAccount: account, showCreateConfirmation: true });
        } else {
          this.setState({ error: 'No account found with this number', fetchedAccount: null });
        }
      } catch (error) {
        this.setState({ error: 'An error occurred while searching for the account', fetchedAccount: null });
      }
    }
  };

  handleCreate = async () => {
    const { fetchedAccount } = this.state;
    if (!fetchedAccount) {
      this.setState({ error: 'No account data available to create' });
      return;
    }
    try {
      const createdAccount = await AccountsStore.createItem(fetchedAccount, 'accounts');
      this.props.onAccountFound(createdAccount);
      this.setState({ showCreateConfirmation: false, isOpen: false, number: '' });
      console.log(AccountsStore.list.accounts);
    } catch (error) {
      this.setState({ error: 'An error occurred while creating the account' });
    }
  };

  handleOpen = () => {
    this.props.onAccountFound(this.state.fetchedAccount);
    this.setState({ showOpenConfirmation: false, number: '' }); // Clear the search value
  };

  handleRevoke = async () => {
    const { fetchedAccount } = this.state;
    try {
      await AccountsStore.revokeAccount(fetchedAccount);
      this.props.onAccountFound(fetchedAccount);
      this.setState({ showRevokeConfirmation: false, isOpen: false, number: '' }); // Clear the search value
      this.props.onOpenEditor(fetchedAccount); // Open the AccountEditor for the revoked account
    } catch (error) {
      this.setState({ error: 'An error occurred while revoking the account' });
    }
  };

  handleClose = () => {
    this.setState({ isOpen: false, number: '' }); // Clear the search value
    this.props.onClose();
  };

  render() {
    const { isOpen } = this.props;
    const { number, error, showCreateConfirmation, showOpenConfirmation, showRevokeConfirmation, fetchedAccount } = this.state;

    return (
      <>
        <Modal show={isOpen} onClose={this.handleClose}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Add Account</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <Form.Field>
                <Form.Label>Number</Form.Label>
                <Form.Control>
                  <Form.Input
                    name="number"
                    value={number}
                    onChange={this.handleChange}
                  />
                </Form.Control>
              </Form.Field>
              {error && <p style={{ color: 'red' }}>{error}</p>}
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button color="success" onClick={this.searchAccount}>Search</Button>
              <Button color="grey" onClick={this.handleClose}>Close</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>

        <Modal show={showCreateConfirmation} onClose={() => this.setState({ showCreateConfirmation: false })}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Confirm Creation</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <p>Account "{fetchedAccount?.bc_bill_name}" found for {number}. Do you want to create an entry for this account?</p>
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button color="success" onClick={this.handleCreate}>Yes, Create</Button>
              <Button onClick={() => this.setState({ showCreateConfirmation: false })}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>

        <Modal show={showOpenConfirmation} onClose={() => this.setState({ showOpenConfirmation: false })}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Account Exists</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <p>Account "{fetchedAccount?.bc_bill_name}" already exists. Do you want to open this entry?</p>
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button color="success" onClick={this.handleOpen}>Yes, Open</Button>
              <Button onClick={() => this.setState({ showOpenConfirmation: false })}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>

        <Modal show={showRevokeConfirmation} onClose={() => this.setState({ showRevokeConfirmation: false })}>
          <Modal.Card>
            <Modal.Card.Header>
              <Modal.Card.Title>Revoke Account</Modal.Card.Title>
            </Modal.Card.Header>
            <Modal.Card.Body>
              <p>Account "{fetchedAccount?.bc_bill_name}" got deleted earlier. Do you want to revoke this account?</p>
            </Modal.Card.Body>
            <Modal.Card.Footer style={{ justifyContent: 'flex-end' }}>
              <Button color="success" onClick={this.handleRevoke}>Yes, Revoke</Button>
              <Button onClick={() => this.setState({ showRevokeConfirmation: false })}>Cancel</Button>
            </Modal.Card.Footer>
          </Modal.Card>
        </Modal>
      </>
    );
  }
}

export default AccountCreate;